import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40426 12C2.40426 6.70042 6.70042 2.40426 12 2.40426C17.2996 2.40426 21.5957 6.70042 21.5957 12C21.5957 17.2996 17.2996 21.5957 12 21.5957C6.70042 21.5957 2.40426 17.2996 2.40426 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM10.4086 7.74043C10.4086 6.86147 11.1211 6.14894 12 6.14894C12.879 6.14894 13.5915 6.86147 13.5915 7.74043V12C13.5915 12.879 12.879 13.5915 12 13.5915C11.1211 13.5915 10.4086 12.879 10.4086 12V7.74043ZM12 4.74468C10.3455 4.74468 9.0043 6.08592 9.0043 7.74043V12C9.0043 13.6545 10.3455 14.9957 12 14.9957C13.6545 14.9957 14.9958 13.6545 14.9958 12V7.74043C14.9958 6.08592 13.6545 4.74468 12 4.74468ZM7.78723 11.6722C7.78723 11.2845 7.47288 10.9701 7.08511 10.9701C6.69733 10.9701 6.38298 11.2845 6.38298 11.6722C6.38298 14.5367 8.52706 16.9003 11.2979 17.2458V18.5531C11.2979 18.9409 11.6122 19.2552 12 19.2552C12.3878 19.2552 12.7021 18.9409 12.7021 18.5531V17.2458C15.4729 16.9003 17.617 14.5367 17.617 11.6722C17.617 11.2845 17.3027 10.9701 16.9149 10.9701C16.5271 10.9701 16.2128 11.2845 16.2128 11.6722C16.2128 13.9985 14.3272 15.8844 12.0011 15.885H12C9.67335 15.885 7.78723 13.9989 7.78723 11.6722Z"
      fill="currentColor"
    />
  </svg>
);
